<template>
  <div id="app">
    <Navbar></Navbar>
    <loader v-if="loaderShow"></loader>
    <div>
      <!-- <v-tour name="myTour" :steps="steps" :callbacks="myCallbacks"></v-tour> -->
      <div v-if="step == 1">
        <Table @update="update"></Table>
      </div>
      <div v-if="step == 2">
        <div class="row mt-4 h-100 justify-content-center">
          <div class="col-sm-12 p-5 m-5 col-md-6 card">
            <h2 class="mb-4">Start Training Your Model</h2>
            <!-- <h2 class="text-center mb-4">Trigger Train</h2> -->
            <label class="text-left mb-2 ml-2">Enter model name</label>
            <input type="text" class="inputSty modelName" placeholder="enter your model name" v-model="mName" />
            <div class="fields fields text-center my-4 py-3 my-4">
              <button
                class="button downloadButton"
                style="width: 50%"
                @click="giveNameToModel"
              >Start</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step == 3">
        <div class="row mt-4 justify-content-center">
          <div class="card col-sm-12 col-md-8 pt-4 py-5 mt-5 col-8">
            <h2 class="modelFile">Upload Your CSV file</h2>

            <form @submit.prevent="onSubmit" class="uploadCsv" enctype="multipart/form-data">
              <div class="button_outer mx-auto my-5">
                <div class="fields">
                  <label class="mt-3">Upload CSV File</label>
                  <br />
                  <input type="file" ref="file" class="inputClass" accept=".csv" @change="onSelect" />
                </div>
              </div>
              <div>
                <p v-if="fileName != ''|| fileName != ' '">{{fileName}}</p>
              </div>
              <div class="fields my-4">
                <button class="button">Submit</button>
              </div>
            </form>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <div v-if="step == 4">
        <div class="mt-5">
          <div class="text-center"><h2 class="finalSelections">Select Options</h2></div>
          <div class="row">
            <div class="col-sm-12 text-left col-md-6 px-5 py-4">
              <label class="ml-2 mb-2 ">Select Numerical Feature</label>
              <div class="d-flex">
                <multiselect
                  class="multi numericalFetures"
                  v-model="selectedPolutant"
                  :multiple="true"
                  placeholder="Please Select"
                  :options="modelTrainPollutant"
                ></multiselect>
              </div>
            </div>
            <div class="col-sm-12 dateTime text-left col-md-6 py-4 px-5">
              <label class="ml-2 mb-2 ">Insert date-time column name</label>
              <br />
              <input
                class="inputSty"
                placeholder="Insert date-time column name"
                type="text"
                v-model="datetime_column"
              />
            </div>
            <div class="col-sm-12 text-left col-md-6 py-4 frequenyColumn px-5">
              <label class="ml-2 mb-2 ">frequency</label>
              <br />
              <select v-model="frequency" class="selectC">
                <option v-for="(fr, i) in frequencyType" :value="fr" :key="i">{{i}}</option>
              </select>
            </div>
            <div class="col-sm-12 text-left col-md-6 py-4 px-5 methodColumn">
              <label class="ml-2 mb-2">Filling missing values</label>
              <br />
              <select v-model="fillType" class="selectC" style="width: 86% !important;">
                <option v-for="(fr, i) in fillTypes" :value="fr" :key="i">{{i}}</option>
              </select>
            </div>
            <div class="fields fields my-4 col-sm-12 col-12 pr-5 my-4">
              <button class="button" style="width: 9rem" @click="preProcess">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '../assets/Logo_Final.png';
import Swal from "sweetalert2";
import Toasted from "vue-toasted";
import Vue from "vue";
import $ from "jquery";
import moment from "moment";
// import Swal from 'sweetalert2';
import { AUTH_LOGOUT } from "../store/actions/auth";
import "vue2-datepicker/index.css";
import { apiCall } from "@/utils/api";
import loader from "./loader";
import Navbar from "./navbar";
import axios from "axios";
import multiselect from "vue-multiselect";
import Table from "./Table";
// import VueTour from "vue-tour";
// import func from '../../vue-temp/vue-editor-bridge';
require("vue-tour/dist/vue-tour.css");

// Vue.use(VueTour);
Vue.use(Toasted);

export default {
  name: "Automl",
  props: {
    msg: String
  },
  components: {
    loader: loader,
    Navbar: Navbar,
    multiselect: multiselect,
    Table: Table
  },
  data() {
    return {
      myCallbacks: {
    onPreviousStep: this.myCustomPreviousStepCallback,
    onNextStep: this.myCustomNextStepCallback
  },
      mName: "",
      fillTypes: { "forward fill": "ffill", "backward fill": "bfill" },
      fillType: "ffill",
      frequencyType: { "1 Hour": "H", "15 minutes": "15min", 'Daily': "D" },
      frequency: "H",
      file: "",
      message: "",
      step: 1,
      loaderShow: false,
      childRows: {},
      price: 5000,
      selectedPolutant: [],
      modelTrainPollutant: ["CO", "NO2", "PM10", "PM25", "SO2", "OZONE"],
      from: "",
      to: "",
      checked: false,
      uploadFileDetails: {},
      datetime_column: "",
      lastTraining: [],
      modelInfo: {},
      fileName: "",
      user: JSON.parse(localStorage.getItem('user')),
      steps: [
        // {
        //   target: ".modelTrain",
        //   header: {
        //     title: "Get Started"
        //   },
        //   content: `Start train your model`
        // },
        // {
        //   target: ".modelName",
        //   header: {
        //     title: 'Model name'
        //   },
        //   content: "Enter model name and start process"
        // },
        // {
        //   target: '.modelFile',
        //   content:
        //     "upload your csv file",
        //   params: {
        //     placement: "top"
        //   }
        // },
        // {
        //   target: ".uploadCsv",
        //   header: {
        //     title: 'Upload csv'
        //   },
        //   content: "Upload csv data file"
        // },
        // {
        //   target: ".finalSelections",
        //   header: {
        //     title: 'Select Options'
        //   },
        //   content: "Select options for your model"
        // },
        // {
        //   target: ".numericalFetures",
        //   content: `<h5 class="text-left">Numerical Feature:</h5> <p class="text-left">Represents some sort of quantitative measurement.
        //    Feature values are numeric Discrete.</p>
        //    <h6 class="text-left"> data:</h6> <p class="text-left">This is integer based, often counts
        //     of some event </p>
        //     <h6 class="text-left">Continuous data:</h6> <p class="text-left">It has an infinite number of possible values.</p>`
        // },
        // {
        //   target: ".dateTime",
        //   content: `<h5 class="text-left">Datetime column:</h5><p class="text-left"> To store a value that contains both date and time. 
        //   Date column is indeed a string and denoted as an object</p>`
        // },
        // {
        //   target: ".frequenyColumn",
        //   content: `<h5 class="text-left">Frequency:</h5><p class="text-left"> To convert TimeSeries data to specified range interval.</p>
        //    <h5 class="text-left">example</h5><p class="text-left">'H': Downsample the timeseries data into hourly interval</p>`
        // },
        // {
        //   target: ".methodColumn",
        //   content: `<h5 class="text-left">Method:</h5><p class="text-left">Missing values are values that are not recorded during data
        //    collection.</p>
        //    <p class="text-left">ffill - Fill missing values with the preceding value (top-down) or</p>
        //     <p class="text-left">bfill - Fill missing values with the succeeding value (bottom-up)</p>`
        // },
      ]
    };
  },
  watch: {
    checked: function(val) {
      if (val) {
        this.selectedPolutant = this.modelTrainPollutant;
      } else {
        this.selectedPolutant = [];
      }
    }
  },
  mounted() {
    // let ths = this
    // $('.modelTrain').addClass("activeClass")
    // this.$tours['myTour'].start();
    // $('.v-tour').css('display', 'none')
    // $(document).ready(function() {
    //   $(document).on('click', '.v-step__button-skip', function(){
    //     // $('.v-tour').css('display', 'none')
    //       ths.step = 1
    //   });
    //   $(document).on('click', '.v-step__button-stop', function() {
    //     ths.step = 1
    //     // $('.v-tour').css('display', 'none')
    //   })
    // });
    
    $(".multiselect__select").attr("style", "height: 34px !important");
    $(".multiselect__placeholder").attr(
      "style",
      "margin-bottom: 3px !important; padding-top: 0px !important; color: #555 !important"
    );
    $(".multiselect__tags").attr(
      "style",
      "min-height: 34px !important;color: #555 !important; font-size: 14px !important; padding-top: 6px !important; padding-left: 10px !important; line-height: 1.4 !important; padding-bottom: 6px !important"
    );
  },
  computed: {},
  methods: {
    myCustomPreviousStepCallback(currentStep) {
      let targetDiv = this.steps[currentStep-1].target
      let prevDiv = this.steps[currentStep].target
      setTimeout(() => {
        $(`${prevDiv}`).removeClass('activeClass')
        $(`${targetDiv}`).addClass("activeClass")
      }, 100)
      if (currentStep < 4 && this.step > 0) {
        this.step -= 1
      }
    },
    myCustomNextStepCallback(currentStep) {
      let targetDiv = this.steps[currentStep+1].target
      let prevDiv = this.steps[currentStep].target
      setTimeout(() => {
        $(`${prevDiv}`).removeClass('activeClass')
        $(`${targetDiv}`).addClass("activeClass")
      }, 100)
      if (this.step < 4) {
          this.step += 1
        } 
    },
    routeToVisualize() {
      this.$router.push("/visualize");
    },
    giveNameToModel() {
      if (this.mName === "" || this.mName === " ") {
        this.$toasted.show("please give model name", { duration: 1000 });
        return;
      }
      const url = `auto_ml`;
      this.loaderShow = true;
      const body = {
        name: this.mName
      };
      apiCall({ url, data: body, method: "post" })
        .then(resp => {
          this.modelInfo = resp.data;
          this.step = 3;
          this.loaderShow = false;
        })
        .catch(err => {
          if (err.message === 'Request failed with status code 301') {
            Swal.fire({
              title: "Only Paid Service",
              text: `Please make payment`,
              type: "success",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Start Payment"
            }).then(result => {
              if (result.value) {
                this.getpayment()
                this.step = 1
              } else {
                this.step = 1
              }
            });
          }
          console.log("error", err);
          this.loaderShow = false;
        });
    },
    getpayment() {
      const options = {
        key: 'rzp_live_J4PaDX6yFUjDFR',
        // amount: 5000,
        name: 'Ambee',
        currency: 'INR',
        description: `subsribe for one month`,
        image: logo,
        handler: (response) => {
          this.verifySignature(response)
        },
        prefill: {
          name: JSON.parse(localStorage.getItem('user')).name,
          email: JSON.parse(localStorage.getItem('user')).email,
        },
        notes: {
          address: JSON.parse(localStorage.getItem('user')).address,
        },
        theme: {
          color: '#2295C8',
        },
      }
      const url = 'payment/order'
      const body = {
        amount: this.price * 100,
        email: JSON.parse(localStorage.getItem('user')).email,
      }
      apiCall({ url, data: body, method: 'post' })
        .then((res) => {
          // console.log('res is here', res)
          this.loaderShow = false
          /* eslint-disable */
          const rzp1 = new Razorpay({ ...options, order_id: res.orderId })
          rzp1.open()
        })
        .catch((err) => { console.log('ERR', err) })
    },
    verifySignature(response) {
      this.loaderShow = true
      const url = 'payment/confirmPayment'
      apiCall({ url, data: { payment: response }, method: 'post' }).then((res) => {
        // delete res.userUpdated._id;
        // delete res.userUpdated.password;
        localStorage.setItem('user', JSON.stringify(res.userUpdated))
        localStorage.setItem('user-token', res.token);
        this.user = res.userUpdated;
        this.loaderShow = false
        Swal.fire({
          title: 'Awesome !',
          text: 'payment successfully !',
          type: 'success',
        })
      }).catch((err) => {
        console.log('error', err)
      })
    },
    update() {
      if (this.user.payment) {
          this.step = 2
        } else {
          Swal.fire({
            title: "Only Paid Service",
            text: `Please make payment`,
            type: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Start Payment"
          }).then(result => {
            if (result.value) {
              this.getpayment()
              this.step = 1
            } else {
              this.step = 1
            }
          });
        }
    },
    callIntervalApi() {
    },
    updateProcess() {
      const url = "auto_ml";
      apiCall({ url, method: "get" })
        .then(() => {})
        .catch(err => {
          console.log(err);
        });
    },
    downloadData() {},
    triggerTrain() {},
    preProcess() {
      this.loaderShow = true;
      if (this.datetime_column === "" || this.datetime_column === " ") {
        this.$toasted.show("please fill input", { duration: 1000 });
        this.loaderShow = false;
        return;
      }
      const fileName = this.uploadFileDetails.Key.split("/");
      const body = {
        raw_file_url: this.uploadFileDetails.Location,
        raw_bucket_name: "ambee-forecast-auto-train",
        raw_file_name: fileName[1],
        numerical_features: this.selectedPolutant,
        datetime_column: this.datetime_column,
        fr: this.frequency,
        method: this.fillType
      };
      // const url = `auto_ml/${this.modelInfo._id}/preprocess`
      const url = `auto_ml/${this.modelInfo._id}/update`;
      apiCall({ url, data: body, method: "put" })
        .then(() => {
          this.step = 4;
          this.loaderShow = false;
          Swal.fire({
            title: "Please Wait",
            text: `now you ready for start preprocess`,
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "continue to dashboard"
          }).then(result => {
            if (result.value) {
              this.step = 1;
            }
          });
        })
        .catch(err => {
          this.loaderShow = false;
          console.log(err);
        });
    },
    onSelect() {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      const file = this.$refs.file.files[0];
      this.file = file;
      this.fileName = this.$refs.file.files[0].name;
      if (!allowedTypes.includes(file.type)) {
        this.message = "Filetype is wrong!!";
      }
      if (file.size > 500000) {
        this.message = "Too large, max size allowed is 500kb";
      }
    },
    async onSubmit() {
      this.loaderShow = true;
      const formData = new FormData();
      formData.append("file", this.file);
      try {
        const token = localStorage.getItem("user-token") || "";
        if (token) {
          axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        }
        await axios
          .put(
            `https://automl-api.getambee.com/upload/${this.modelInfo._id}/${this.modelInfo.name}`,
            formData
          )
          .then(r => {
            this.modelTrainPollutant = r.data.keys;
            this.uploadFileDetails = r.data.data;
            this.step = 4;
            this.loaderShow = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    uploadFile() {
      var file = this.$refs.docsUpload.files[0];
      const token = localStorage.getItem("user-token") || "";
      var ths = this;
      if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      }
      axios
        .post("http://13.233.166.48:3001/upload/uploadFIle/v2", file)
        .then(function(response) {
          ths.step = 3;
          ths.uploadFileDetails = response.data.data;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
    getTime(thingkey, pollutantName) {
      let currentTime = this.rows.filter(row => {
        return row.thingKey === thingkey;
      })[0];
      return moment(currentTime[pollutantName].startedAt).format(
        "DD-MM-YY HH:mm:ss"
      );
    },
    toggle(id) {
      // this.$router.push(`/Device`)
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.push(id);
      }
    }
  },
  created() {
    var intval = setInterval(() => {
      if (this.percentage < 100) this.percentage += 0.1;
      else clearInterval(intval);
    }, 10);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.downloadButton {
  width: 20rem;
  height: 5rem;
}
.selectC {
  background: white;
  border: 1px solid #e8e8e8;
  color: #555;
  border-radius: 6px;
  min-height: 34px;
  font-size: 14px;
  padding-top: 6px;
  padding-left: 10px;
  line-height: 1.4;
  padding-bottom: 6px;
}
.inputSty {
  min-height: 34px;
  color: #555;
  font-size: 14px;
  padding-top: 6px;
  padding-left: 10px;
  line-height: 1.4;
  padding-bottom: 6px;
  width: 86%;
  padding-left: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.logoutFont {
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
.multi {
  /* z-index: 99; */
  height: auto;
  width: 80% !important;
}

.details {
  color: white;
}
/*custom font*/

/* @primary-color: #63a2cb; */
/* @#67d5bf: #67d5bf; */
/*basic reset*/
* {
  margin: 0;
  padding: 0;
}

html {
  height: 100%;
  background: #0e0e0e;
}

body {
  font-family: "Open Sans", arial, verdana;
}
/*headings*/
.fs-title {
  font-size: 16px;
  text-transform: uppercase;
  color: #63a2cb;
  margin-bottom: 10px;
}
.fs-subtitle {
  font-weight: normal;
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.help-block {
  font-size: 0.8em;
  color: #7c7c7c;
  text-align: left;
  margin-bottom: 0.5em;
}
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

select {
  height: 34px !important;
  width: 80% !important;
}

a.button {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  padding: 0;
  margin: 10px 20px 10px 0;
  font-weight: 600;
  text-align: center;
  line-height: 50px;
  color: #fff;
  border-radius: 5px;
  transition: all 0.2s;
}

a,
a:visited {
  text-decoration: none;
  color: white !important;
}
.button {
  width: 6rem;
  height: 3rem;
  /* margin: 1rem; */
  border: 1px solid blue;
  color: white;
  background: cadetblue;
  /* padding: 1rem; */
  border-radius: 20px;
}
.button_outer {
  background: #83ccd3;
  border-radius: 30px;
  text-align: center;
  height: 50px;
  width: 200px;
  display: inline-block;
  transition: 0.2s;
  position: relative;
  overflow: hidden;
}
.btn_upload {
  padding: 17px 30px 12px;
  color: #fff;
  text-align: center;
  position: relative;
  display: inline-block;
  overflow: hidden;
  z-index: 3;
  white-space: nowrap;
}
.inputClass {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  width: 100%;
  height: 105%;
  cursor: pointer;
  opacity: 0;
}
</style>
